import { api } from '../../../../app/baseQuery';
import { HTTPResponse } from '../../../../common/types/commonTypes';
import { IAirTicketSummary } from '../../AirTicketReport/Interfaces/AirTicketReport.interfaces';
import { IAirlineWiseSalesReportDataType } from '../types/AirlineWiseSalesReportTypes';

export const AirlineWiseSalesReportEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    // get all Airline Wise Sales Report
    getAirlineWiseSalesReport: build.query<
      HTTPResponse<IAirlineWiseSalesReportDataType>,
      {
        airline_id: string | number;
        query: string;
      }
    >({
      query: ({ airline_id, query }) => ({
        url: `/report/airline-wise-sales-report/${airline_id}${query}`,
      }),
      providesTags: [{ type: 'AirlineReport', id: 'AIRLINE' }],
    }),
    getAirTicketSummary2: build.query<
      HTTPResponse<IAirTicketSummary[]>,
      {
        query: any;
      }
    >({
      query: (query) => ({
        url: `/report/air-ticket-summary${query}`,
      }),
      providesTags: [{ type: 'AirlineReport', id: 'AIRLINE' }],
    }),
    getAirTicketSummaryv2: build.query<HTTPResponse<IAirTicketSummary[]>, any>({
      query: (query) => ({
        url: `/report/air-ticket-summary`,
        params: query,
      }),
      providesTags: [{ type: 'AirlineReport', id: 'AIRLINE' }],
    }),
    getPriorityClientFlightTracker: build.query<HTTPResponse<IAirTicketSummary[]>, any>({
      query: (query) => ({
        url: `/report/priority-client-flight-tracker`,
        params: query,
      }),
      providesTags: [{ type: 'AirlineReport', id: 'AIRLINE' }],
    }),
    getClientGdsSignature: build.query<HTTPResponse<IAirTicketSummary[]>, any>({
      query: (query) => ({
        url: `/report/client-gds-signatures`,
        params: query,
      }),
      providesTags: [{ type: 'AirlineReport', id: 'AIRLINE' }],
    }),
  }),
});

export const {
  useLazyGetAirlineWiseSalesReportQuery,
  useLazyGetAirTicketSummary2Query,
  useGetAirTicketSummary2Query,
  useLazyGetAirTicketSummaryv2Query,
  useLazyGetPriorityClientFlightTrackerQuery,
  useLazyGetClientGdsSignatureQuery,
} = AirlineWiseSalesReportEndpoints;
